var _g, _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 101,
    viewBox: "0 0 114 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3559_364)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53,
    cy: 88.5,
    rx: 53,
    ry: 12.5,
    fill: "url(#paint0_radial_3559_364)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4697 5.73175C49.0471 4.60976 50.9939 4 52.9985 4C55.0031 4 56.9498 4.60976 58.5273 5.73175L63.1788 9.03848C64.8476 10.2232 66.9218 10.8351 69.0351 10.7643L74.946 10.5698C76.949 10.5035 78.9188 11.0482 80.5403 12.117C82.1617 13.1857 83.3413 14.7168 83.8903 16.4654L85.5123 21.6217C86.0894 23.4678 87.3721 25.0699 89.1306 26.1415L94.0356 29.1335C97.4589 31.2201 98.8703 35.1563 97.455 38.6717L95.4236 43.7078C94.6961 45.5108 94.6961 47.4892 95.4236 49.2921L97.4511 54.3283C98.14 56.0356 98.1779 57.9031 97.5587 59.6322C96.9395 61.3614 95.699 62.8523 94.0356 63.8665L89.1306 66.8585C87.376 67.9301 86.0894 69.5322 85.5123 71.3783L83.8903 76.5346C83.3413 78.2832 82.1617 79.8142 80.5403 80.883C78.9188 81.9518 76.949 82.4965 74.946 82.4302L69.0351 82.2357C66.9195 82.1653 64.8448 82.7768 63.1788 83.9615L58.5273 87.2682C56.9498 88.3902 55.0031 89 52.9985 89C50.9939 89 49.0471 88.3902 47.4697 87.2682L42.8182 83.9615C41.1521 82.7768 39.0774 82.1653 36.9618 82.2357L31.0509 82.4302C29.0486 82.4957 27.0797 81.9506 25.459 80.8819C23.8384 79.8132 22.6594 78.2826 22.1105 76.5346L20.4885 71.3783C19.909 69.5312 18.6272 67.93 16.8702 66.8585L11.9614 63.8665C10.2979 62.8523 9.05743 61.3614 8.43824 59.6322C7.81906 57.9031 7.85695 56.0356 8.54586 54.3283L10.5772 49.2921C11.3064 47.4885 11.3064 45.508 10.5772 43.7043L8.54976 38.6717C7.86047 36.9648 7.82198 35.0975 8.44044 33.3684C9.05891 31.6393 10.2986 30.1482 11.9614 29.1335L16.8741 26.1415C18.6287 25.0699 19.9115 23.4678 20.4885 21.6217L22.1105 16.4654C22.6596 14.7168 23.8391 13.1857 25.4606 12.117C27.0821 11.0482 29.0518 10.5035 31.0548 10.5698L36.9657 10.7643C39.0813 10.8347 41.156 10.2232 42.8221 9.03848L47.4697 5.73175Z",
    fill: "#E95B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 39C68.4259 36.7361 64.2222 33.5667 60 39",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 39C43.4259 36.7361 39.2222 33.5667 35 39",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 26C46.6667 27.6667 43.2 30.7 36 29.5",
    stroke: "#C0360A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 26C58.7971 27.7665 62.113 30.9817 69 29.7097",
    stroke: "#C0360A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 17.8563C76.0001 17.8562 76.0002 17.8563 76.0002 17.8563C76.0002 21.8018 78.9094 25 82.4983 25C86.0646 25 88.9597 21.842 88.9961 17.931C88.9966 17.8814 88.9976 17.8343 88.9987 17.7847C89.0152 17.0092 88.9738 10.0903 82.5036 5.00454C82.5035 5.00444 82.5034 5.0043 82.5033 5.00415L82.5025 5.00177C82.5022 5.00096 82.5011 5.00083 82.5003 5.00125C82.5001 5.00138 82.4999 5.00138 82.4997 5.00125C82.4989 5.00083 82.4978 5.00096 82.4975 5.00177L82.4968 5.00374C82.4966 5.00416 82.4963 5.00454 82.496 5.00482C76.0007 10.111 75.9845 17.0605 76.0016 17.7893C76.0013 17.8118 76 17.8339 76 17.8562C76 17.8563 76 17.8563 76.0001 17.8563Z",
    fill: "#88C7F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_3559_364",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 48C40.3431 48 38.958 49.3796 39.5099 50.9418C40.1503 52.7545 41.3777 54.4245 43.1005 55.7782C45.726 57.8411 49.287 59 53 59C56.713 59 60.274 57.8411 62.8995 55.7782C64.6223 54.4245 65.8497 52.7545 66.4901 50.9418C67.042 49.3796 65.6569 48 64 48L53 48L42 48Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48C40.3431 48 38.958 49.3796 39.5099 50.9418C40.1503 52.7545 41.3777 54.4245 43.1005 55.7782C45.726 57.8411 49.287 59 53 59C56.713 59 60.274 57.8411 62.8995 55.7782C64.6223 54.4245 65.8497 52.7545 66.4901 50.9418C67.042 49.3796 65.6569 48 64 48L53 48L42 48Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-8-inside-1_3559_364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3559_364",
    x: -125,
    y: -49,
    width: 356,
    height: 275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 62.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3559_364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3559_364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3559_364",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53 88.5) rotate(90) scale(12.5 40.251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802181,
    stopColor: "#ABABAB",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/NoAccess.05e52ce83061c83377f22294680d147f.svg";
export { ForwardRef as ReactComponent };